import React from 'react';
import { CountingCirclesRecord } from 'api/api.types';
import classNames from 'classnames';
import { ReactComponent as Map } from './worldmap.svg';
import { VOTERS_ABROAD_BFS_NRS } from './useMapApi';

export const VOTERS_ABROAD_NAME = 'Auslandschweizer';

interface Props {
  isNational: boolean;
  records: CountingCirclesRecord[];
  map: string;
}

const WorldMap = ({ isNational, records, map }: Props) => {
  // The bfs_number can change in the future. Also, archive-data records have no bfs-numbers
  // Thus, we also use the name to ensure, we always find the record
  const votersAbroadRecord = records?.find(
    (record) =>
      record.name.de === VOTERS_ABROAD_NAME ||
      VOTERS_ABROAD_BFS_NRS.includes(record.bfs_number),
  );

  const showWorldMap = Boolean(isNational && votersAbroadRecord && map);

  if (!showWorldMap) return null;

  // These props are passed into the worldmap svg to be able to target it as any other municipality.
  // The bfs_number should be static but was changed in April 2023 and could change in the future.
  const MAP_IDENTIFIER = {
    'agis:gmdnr': votersAbroadRecord?.bfs_number || VOTERS_ABROAD_BFS_NRS[0],
    'agis:gmdname': VOTERS_ABROAD_NAME,
    className: classNames('worldmap', {
      'worldmap--with-result': votersAbroadRecord?.results,
    }),
  };

  return <Map {...(MAP_IDENTIFIER as any)} />;
};

export default WorldMap;
